import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBranding } from "../context/BrandingContext";
const MockQuestionComponent = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { colors } = useBranding();

  const openModal = () => {
    setIsOpen(true);
    document.getElementById("mainContent").classList.add("blurred");
  };

  const closeModal = () => {
    setIsOpen(false);
    document.getElementById("mainContent").classList.remove("blurred");
  };
  return (
    <>
      <div id="mainContent" style={{ margin: "20px" }}>
        <div className="container">
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <div className="quiz-section">
              <h2>Free Mock Test</h2>
              <p className="question-count">Question 01 of 16</p>
              <div className="progress-bar">
                <div className="progress"></div>
              </div>
              <h3 className="question">
                Quantitative Question 01: If 2x + 3 = 9, What Is The Value Of X
              </h3>
              <p className="subtext">
                Get a feel for the GRE with our 16-question sample test
              </p>
              <div className="options-grid">
                <label className="custom-option">
                  <input type="checkbox" />
                  <span className="custom-box"></span>
                </label>
                <label className="custom-option">
                  <input type="checkbox" />
                  <span className="custom-box"></span>
                </label>
                <label className="custom-option">
                  <input type="checkbox" />
                  <span className="custom-box"></span>
                </label>
                <label className="custom-option">
                  <input type="checkbox" />
                  <span className="custom-box"></span>
                </label>
              </div>

              <div className="buttons">
                <button
                  onClick={() => { navigate('/dashboard') }}
                  className="btn gray"
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ transform: "rotate(180deg)" }}
                    >
                      <path
                        d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span style={{ marginBottom: "2px" }}> Previous </span>
                </button>
                <button
                  className="btn black submit-btn"
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                  onClick={openModal}

                >
                  <span style={{ marginBottom: "3px" }}> Submit Test </span>
                  <span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>

            <div className="status-section">
              <h2>Free Mock Test</h2>
              <div className="legend">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 10V19.5C21 20.3285 20.3285 21 19.5 21H4.5C3.67158 21 3 20.3285 3 19.5V4.5C3 3.67158 3.67158 3 4.5 3H15"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 10L13 14L20.5 3.5"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Answered</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z"
                        fill="#0F0F0F"
                      ></path>
                    </g>
                  </svg>
                  <span>Unanswered</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 0C13.9174 0 16.7153 1.15893 18.7782 3.22183C20.8411 5.28473 22 8.08262 22 11C22 13.9174 20.8411 16.7153 18.7782 18.7782C16.7153 20.8411 13.9174 22 11 22C8.08262 22 5.28473 20.8411 3.22183 18.7782C1.15893 16.7153 0 13.9174 0 11C0 8.08262 1.15893 5.28473 3.22183 3.22183C5.28473 1.15893 8.08262 0 11 0ZM2.0625 11C2.0625 13.3704 3.00413 15.6437 4.68023 17.3198C6.35634 18.9959 8.62963 19.9375 11 19.9375C13.3704 19.9375 15.6437 18.9959 17.3198 17.3198C18.9959 15.6437 19.9375 13.3704 19.9375 11C19.9375 8.62963 18.9959 6.35634 17.3198 4.68023C15.6437 3.00413 13.3704 2.0625 11 2.0625C8.62963 2.0625 6.35634 3.00413 4.68023 4.68023C3.00413 6.35634 2.0625 8.62963 2.0625 11ZM15.51 7.9475L7.9475 15.51C7.82145 15.6457 7.66112 15.745 7.48341 15.7973C7.30569 15.8495 7.11716 15.8529 6.93769 15.807C6.75822 15.7611 6.59445 15.6677 6.46363 15.5365C6.33282 15.4054 6.2398 15.2413 6.19438 15.0618C6.14858 14.8825 6.15186 14.6942 6.20387 14.5166C6.25588 14.339 6.35471 14.1787 6.49 14.0525L14.0525 6.49C14.248 6.30762 14.5066 6.20826 14.7739 6.21288C15.0412 6.21749 15.2962 6.32572 15.4853 6.51475C15.6743 6.70378 15.7825 6.95884 15.7871 7.22612C15.7917 7.49341 15.6924 7.75205 15.51 7.9475Z"
                      fill="black"
                    />
                  </svg>
                  <span>Skipped</span>
                </div>
              </div>

              <div className="grid">
                <div className="box answered">1</div>
                <div className="box answered">2</div>
                <div className="box unanswered">3</div>
                <div className="box unanswered">4</div>
                <div className="box answered">5</div>
                <div className="box answered">6</div>
                <div className="box answered">7</div>
                <div className="box answered">8</div>
                <div className="box answered">9</div>
                <div className="box answered">10</div>
                <div className="box answered">11</div>
                <div className="box unanswered">12</div>
                <div className="box skipped">13</div>
                <div className="box unanswered">14</div>
                <div className="box answered">15</div>
                <div className="box current">16</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <div id="submitModal" className="modal-overlay">
          <div className="modal-content" style={{ background: colors.popupBg }}>
            <h2>Are you sure you want to submit your answers for this
              section and quit it?</h2>
            <p>
              Clicking 'Quit w/Save' will close this section with saving your answers.You will not be able to return to this section to review or answer any unanswered questions.
            </p>
            <div className="modal-buttons">
              <button className="btn border-btn" onClick={closeModal}
                style={{ backgroundColor: "transparent", borderColor: colors.buttonBg }}
              >
                Cancel
              </button>
              <button onClick={() => { navigate('/result') }} className="btn black"
                style={{ backgroundColor: colors.buttonBg }}
              >Submit</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MockQuestionComponent;
